import { render, staticRenderFns } from "./MiPerfilPersona.vue?vue&type=template&id=95ab2f9c&scoped=true&"
import script from "./MiPerfilPersona.vue?vue&type=script&lang=js&"
export * from "./MiPerfilPersona.vue?vue&type=script&lang=js&"
import style0 from "./MiPerfilPersona.vue?vue&type=style&index=0&id=95ab2f9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ab2f9c",
  null
  
)

export default component.exports